// Content Service - Home page sections managed from Admin → Customize
import { apiRequest } from './api';

export const contentService = {
  // Each section is null when the admin has turned it off
  async getHomeContent() {
    return apiRequest('/content/home');
  },

  async subscribeNewsletter(email) {
    return apiRequest('/newsletter', { method: 'POST', body: { email } });
  }
};
